import { FC } from 'react';
import { UserDetails } from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';
import { getFullName } from '@frontend/name';
import { Avatar, Text } from '@frontend/design-system';
import { AIR_RECEPTIONIST_MOCK_ID } from '../../../constants';

interface PersonRenderItemProps {
  user: UserDetails;
}

export const PersonRenderItem: FC<PersonRenderItemProps> = ({ user }) => {
  const name = getFullName(user) || 'Unknown User';
  return (
    <>
      <Avatar
        size='xs'
        name={name}
        isUser
        {...(user.userId === AIR_RECEPTIONIST_MOCK_ID && { isAiAssistant: true, isUser: false })}
      />
      <Text size='large'>{name}</Text>
    </>
  );
};
